'use client';

import PageType from '@alltrails/amplitude/enums/PageType';
import logShowMoreClicked from '@alltrails/amplitude/events/logShowMoreClicked';
import ShowMoreText from '@alltrails/layout/components/ShowMoreText/ShowMoreText';
import useMediaQuery from '@alltrails/core/hooks/useMediaQuery';
import { BREAKPOINT_MD_SIZE } from '@alltrails/denali/tokens';
import styles from './Description.module.scss';

type Props = {
  descriptionText: string;
  pageType?: PageType;
  descriptionHtml?: string;
  textComponent?: React.ReactNode;
};

const ExpandableDescription = ({ descriptionText, pageType, descriptionHtml, textComponent }: Props) => {
  const isMobile = useMediaQuery(`(max-width: ${BREAKPOINT_MD_SIZE}px)`);
  const defaultMaxLines = isMobile ? 2 : 3;

  return (
    <ShowMoreText
      text={descriptionHtml || descriptionText}
      textComponent={textComponent}
      innerHtml={descriptionHtml}
      className={styles.locationDescription}
      maxLines={defaultMaxLines}
      testIdPrefix="location-description"
      useShortText
      skipHtmlSanitization
      onClick={() => {
        if (pageType) logShowMoreClicked({ page_type: pageType, show_more_location: 'overview' });
      }}
    />
  );
};

export default ExpandableDescription;
